import type { ReactNode } from 'react';
import type { SecretState } from '@/api/types';
import { Button, FieldHint, Input } from '@/design-system';
import s from './settings.module.css';

export type SecretLabels = {
  /** the field's name */
  label: string;
  /** «Задан: ••••a1b2» */
  set: (masked: string) => string;
  unset: string;
  /** the password input's placeholder and name («Новый ключ (пусто — оставить текущий)») */
  replace: string;
  clear: string;
  willClear: string;
  hint?: ReactNode;
};

/**
 * A write-only secret (P1-F04, P3-E04): the server's {set, masked} state, a password input for a new
 * value (sent only when typed), and «Удалить» to send null. The typed value lives only in the form.
 */
export function SecretField({
  labels,
  state,
  value,
  clearing,
  onType,
  onClear,
  testId,
}: {
  labels: SecretLabels;
  state: SecretState | undefined;
  value: string;
  clearing: boolean;
  onType: (value: string) => void;
  onClear: () => void;
  testId?: string;
}) {
  return (
    <div className={s.group}>
      <span className={s.groupLabel}>{labels.label}</span>
      <span className={s.secretState} data-testid={testId}>
        {clearing ? labels.willClear : state?.set ? labels.set(state.masked ?? '••••') : labels.unset}
      </span>
      <Input
        aria-label={labels.replace}
        type="password"
        autoComplete="off"
        spellCheck={false}
        placeholder={labels.replace}
        value={value}
        mono
        onChange={(e) => onType(e.target.value)}
      />
      {state?.set && !value && (
        <Button variant="secondary" size={34} icon="trash-2" iconSize={14} className={s.alignStart} onClick={onClear}>
          {labels.clear}
        </Button>
      )}
      {labels.hint && <FieldHint>{labels.hint}</FieldHint>}
    </div>
  );
}
